import CommerceService from "../../CommerceService"

const CommerceOrder = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/orders'
        if (r != undefined) {
            url = '/orders?' + r
        }
        return CommerceService.get(url)
    },
    get(ref) {
        const url = `/orders/ref/${ref}`;
        return CommerceService.get(url)
    },
    basket(data) {
        const url = `/basket`;
        return CommerceService.post(url, data)
    },
    create(data) {
        const url = `/orders`;
        return CommerceService.post(url, data)
    }
}
export default CommerceOrder
